import type { Comment as CommentType } from "@/react/types/Comment";

import { Comment } from "./Comment";
import { RepliesList } from "./RepliesList";
import { CommentsThreadProvider } from "./ThreadContext";

interface ThreadProps {
  allRepliesPreloaded?: boolean;
  comment: CommentType;
  defaultReplyFormOpen?: boolean;
}

export const Thread = ({
  comment,
  allRepliesPreloaded = false,
  defaultReplyFormOpen = false,
}: ThreadProps) => (
  <CommentsThreadProvider
    commentId={comment.id}
    defaultReplyFormOpen={defaultReplyFormOpen}
  >
    <div className="grid grid-cols-[2rem_2rem_1fr_auto] gap-x-3 gap-y-1">
      <Comment comment={comment} />
      <RepliesList
        parentComment={comment}
        allRepliesPreloaded={allRepliesPreloaded}
      />
    </div>
  </CommentsThreadProvider>
);
